import Pet from '~models/pet'
import Vet from '~models/vet'
import { SocialPlatform } from '~types'

type ConsultationCount = Readonly<{
  waiting: number
  answered: number
}>

namespace Owner {
  export interface ILevel1 {
    id: number
    nickname: string
    default_nickname: string
    custom_name: string | null
    thumbnail_uri: string | null
    following: boolean
    community_operator: boolean
    first_name: string | null
    last_name: string | null
    account_email: string | null
    customer_email: string | null
    private_name: string | null
    consultation_count: ConsultationCount
    bio: string | null
    instagram_id: string | null
  }

  export class Level1 implements ILevel1 {
    id: number
    nickname: string
    default_nickname: string
    custom_name: string | null
    thumbnail_uri: string | null
    following: boolean
    community_operator: boolean
    first_name: string | null
    last_name: string | null
    account_email: string | null
    customer_email: string | null
    private_name: string | null
    consultation_count: ConsultationCount
    bio: string | null
    instagram_id: string | null

    constructor(props: Readonly<ILevel1>) {
      this.id = props.id
      this.nickname = props.nickname
      this.default_nickname = props.default_nickname
      this.custom_name = props.custom_name
      this.thumbnail_uri = props.thumbnail_uri
      this.following = props.following
      this.community_operator = props.community_operator
      this.first_name = props.first_name
      this.last_name = props.last_name
      this.account_email = props.account_email
      this.customer_email = props.customer_email
      this.private_name = props.private_name
      this.consultation_count = props.consultation_count
      this.bio = props.bio
      this.instagram_id = props.instagram_id
    }
  }

  export interface ILevel2 extends ILevel1 {
    created_at: string
    num_of_comment: number
    num_of_follower: number
    num_of_following: number
    num_of_post: number
    num_of_medical_records: number
    phone_number: string | null
    social_platform: SocialPlatform | null
    pets: Pet.Level1[]
    vet: Vet.Level1 | null
    last_updated_at: number
    last_inbox_checked_at: string
    unchecked_inbox_message_count: number
    notification: 0 | 1 // 0: off, 1: on
    // owner_sync_medical_records: SynchronizeMedicalRecordsParams[] | null;
    medical_record_count: {
      forwarded: number
      uploaded: number
    }
    // ab_test?: {};
    is_admin: boolean
  }

  export class Level2 extends Level1 implements ILevel2 {
    created_at: string
    num_of_comment: number
    num_of_follower: number
    num_of_following: number
    num_of_post: number
    num_of_medical_records: number
    phone_number: string | null
    social_platform: SocialPlatform | null
    pets: Pet.Level1[]
    vet: Vet.Level1 | null
    last_updated_at: number
    last_inbox_checked_at: string
    unchecked_inbox_message_count: number
    notification: 0 | 1 // 0: off, 1: on
    // owner_sync_medical_records: SynchronizeMedicalRecordsParams[] | null;
    medical_record_count: {
      forwarded: number
      uploaded: number
    }
    // ab_test?: {};
    is_admin: boolean

    constructor(props: Readonly<ILevel2>) {
      super(props)
      this.created_at = props.created_at
      this.num_of_post = props.num_of_post
      this.num_of_comment = props.num_of_comment
      this.num_of_follower = props.num_of_follower
      this.num_of_following = props.num_of_following
      this.phone_number = props.phone_number
      this.social_platform = props.social_platform
      this.pets = props.pets
      this.vet = props.vet
      this.last_inbox_checked_at = props.last_inbox_checked_at
      this.unchecked_inbox_message_count = 0
      this.last_updated_at = Math.round(+new Date() / 1000)
      this.notification = props.notification
      // this.owner_sync_medical_records = props.owner_sync_medical_records;
      this.medical_record_count = props.medical_record_count
      this.num_of_medical_records = Object.values(this.medical_record_count).reduce(
        (acc, cur) => acc + cur,
        0
      )
      this.is_admin = props.is_admin
      // this.ab_test = props.ab_test;
    }
  }

  export type MissionItem = {
    id: number
    /**
     * unique name of mission;
     */
    name: MissionItemIdentifier
    image_url: string
    title: string
    description: string
    label: string | null
    /**
     * ex) question/37
     */
    link: string
    /**
     * 언제 이 미션이 활성화가 되었는지 혹은 활성화 될 예정인지(not null)
     */
    activated_at: string
    latest_done_at: string | null
    /**
     * 값이 작을 수록 상단에 위치
     */
    sequence: number
    /**
     * true인 애들만 PATCH method API로 수정 가능. 현재 시점에서 `onboarding_completed` 미션만 true임.
     */
    manual_updatable: boolean
    is_recurring: boolean
    /**
     * 미션 달성 시 지급되는 포인트(PAWS)
     */
    point_amount: number

    /**
     * 베네핏 탭 미션리스트 표시 여부
     */
    displayed: boolean
  }
}

export default Owner

export enum MissionItemIdentifier {
  RequestMedicalRecordsSync = 'sync_medical_record_requested',
  HasConsultation = 'has_consultation',
}
